/** Curated cinematic imagery (design_guidelines.json image_urls), sized for web. */
const px = (url, w) => `${url}?auto=compress&cs=tinysrgb&w=${w}`;
const us = (url, w) => `${url}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  coachPortrait: px("https://images.pexels.com/photos/38516877/pexels-photo-38516877.jpeg", 900),
  creativeTraining: us("https://images.unsplash.com/photo-1554244933-d876deb6b2ff", 800),
  womenStrength: px("https://images.pexels.com/photos/36389485/pexels-photo-36389485.jpeg", 800),
  execTraining: us("https://images.unsplash.com/photo-1521804906057-1df8fdb718b7", 800),
  social1: px("https://images.pexels.com/photos/7674490/pexels-photo-7674490.jpeg", 700),
  social2: px("https://images.pexels.com/photos/13106615/pexels-photo-13106615.jpeg", 700),
  social3: px("https://images.pexels.com/photos/4325489/pexels-photo-4325489.jpeg", 700),
  social4: us("https://images.unsplash.com/photo-1758875570137-8691b7c55033", 700),
};
